<template lang="pug">
  div
    top-nav(headerColor="white")
    .placeholder(v-if="loading")
    .content.exhibitions(v-if='!loading')
      .grid
        .col-12.no-bottom
          h2.category
            | exhibitions
          h2#current
            | on view
        .col-12
          .screen(v-if='!loading')
            router-link(:to="{name: 'exhibition-single', params: {year: startYear(current.main), id: current.main.uid }}")
              visual(:image="current.main.image" background="cover" role="img" :aria-label="altText")
                .captions
                  h2.title
                    | exhibition
                  h1
                    | {{ title(current.main) }}
                  h2
                    | {{ date(current.main) }}
        .col-6_xs-12(v-for="exhibition in current.exhibitions")
          .screen(v-if='!loading', :key="title(exhibition)")
            router-link(:to="{name: 'exhibition-single', params: {year: startYear(exhibition), id: exhibition.uid }}")
              visual(:image="exhibition.image" background="cover" role="img" :aria-label="exhibition.title")
                .captions
                  h2.title
                    | exhibition
                  h1
                    | {{ title(exhibition) }}
                  h2
                    | {{ date(exhibition) }}
      .grid#further-exhibitions
        .col-6_xs-12
          h2#upcoming
            | upcoming
          .half-screen(v-if='!loading')
            router-link(
              :to="{name: 'exhibitions-overview', params: {year: 'upcoming'}}"
            )
              visual(:image="upcomingFeatured" background="cover" role="img" aria-label="Upcoming Exhibitions")
        .col-6_xs-12(v-if='traveling.image')
          h2#traveling
            | traveling
          .half-screen(v-if='!loading')
            router-link(
              :to="{name: 'exhibitions-overview', params: {year: 'traveling'}}"
            )
              visual(:image="travelingFeatured" background="cover" role="img" aria-label="Traveling Exhibitions")
        .col-6_xs-12
          h2#past
            | past
          .half-screen(v-if='!loading')
            router-link(
              :to="{name: 'exhibitions-overview', params: {year: 'past'}}"
            )
              visual(:image="pastFeatured" background="cover" role="img" aria-label="Past Exhibitions")
    bottom-nav(footerColor="white")
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'exhibitions',
  mixins: [DataMixin, ComponentMixin],

  data () {
    return {
      swiperOption: {
        notNextTick: true,
        autoplay: false,
        direction: 'horizontal',
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
        mousewheelControl: false,
        observeParents: true,
        debugger: true,
        onTransitionStart (swiper) {
        }
      }
    }
  },

  created () {
    this.loading = false
    this.requestData('exhibitions', 'exhibitions')
  },

  methods: {
    startDate: function (exhibition) {
      return exhibition.content.start_date
    },

    endDate: function (exhibition) {
      return exhibition.content.end_date
    },

    startYear: function (exhibition) {
      return exhibition.content.start_year
    },

    endYear: function (exhibition) {
      return exhibition.content.end_year
    },

    date: function (exhibition) {
      const endDate = this.endDate(exhibition) + ', ' + this.endYear(exhibition)
      let startDate = this.startDate(exhibition)
      if (this.endYear(exhibition) !== this.startYear(exhibition)) {
        startDate = this.startDate(exhibition) + ', ' + this.startYear(exhibition)
      }
      return startDate + ' - ' + endDate
    },

    title: function (exhibition) {
      return exhibition.content.title
    }
  },

  computed: {
    current: function () {
      const data = this.loadedData.exhibitions.current
      const main = data.splice(0, 1)[0]
      const current = {
        main,
        exhibitions: data
      }
      return current
    },

    traveling: function () {
      if (this.loadedData.exhibitions.traveling.length === 0) {
        return false
      } else {
        return this.loadedData.exhibitions.traveling
      }
    },

    upcoming: function () {
      return this.loadedData.exhibitions.upcoming
    },

    upcomingHero: function () {
      if (this.upcoming.length > 0) {
        return this.upcoming[0].image
      } else {
        return false
      }
    },

    past: function () {
      return this.loadedData.exhibitions.past
    },

    key: function () {
      return 'exhibitions'
    },

    pastFeatured: function () {
      return this.loadedData.exhibitions.past_featured
    },

    travelingFeatured: function () {
      return this.loadedData.exhibitions.traveling_featured
    },

    upcomingFeatured: function () {
      return this.loadedData.exhibitions.upcoming_featured
    },

    altText: function () {
      return this.current.main.title
    }
  },

  watch: {
    $route: function () {
      if (this.$route.query.status === 'past') {
        this.$router.replace({name: 'exhibitions-overview', params: {year: 'past'}})
      } else if (this.$route.query.status === 'traveling') {
        this.$router.replace({name: 'exhibitions-overview', params: {year: 'traveling'}})
      } else if (this.$route.query.status === 'future') {
        if (!this.loading) {
          document.getElementById('future').scrollIntoView()
          window.scrollBy(0, -150)
        }
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    if (to.query.status === 'past') {
      next(vm => {
        vm.$router.replace({name: 'exhibitions-overview', params: {year: 'past'}})
      })
    } else if (to.query.status === 'traveling') {
      next(vm => {
        vm.$router.replace({name: 'exhibitions-overview', params: {year: 'traveling'}})
      })
    } else if (to.query.status === 'future') {
      next(vm => {
        if (!vm.loading) {
          document.getElementById('future').scrollIntoView()
          window.scrollBy(0, -150)
        }
      })
    }
    next()
  }
}
</script>

<style lang="sass">
  @import '../styles/main'
  .exhibitions
    #upcoming, #past, #traveling
      margin-top: 9rem
      margin-bottom: 3rem
      @include respond-to(xs)
        margin: 0
    #traveling, #past
      @include respond-to(xs)
        margin: 0
    h2
      letter-spacing: $kerningTight
      @include respond-to(xs)
        letter-spacing: $kerningTightMobile
    .category
      color: $exhibitions
      @include respond-to(xs)
        font-size: 2.5rem
        margin-bottom: 2rem
    .no-bottom
      @include respond-to(xs)
        padding-bottom: 0
    .screen
      width: 100%
      height: 76.5vH
      @include respond-to(xs)
        padding-bottom: 58%
        height: 0
      .vv-image
        width: 100%
        height: 76.5vH
        @include respond-to(xs)
          padding-bottom: 58%
          height: 0
    .screen, .half-screen, .gallery-desktop
      .vv-visual
        &:hover .captions
          opacity: 1
          @include transition(opacity, 0.2s, ease-in-out)
        .vv-image
          background-repeat: no-repeat
          background-size: cover
      .captions
        opacity: 0
        padding: 0
        width: 100%
        height: unset
        padding-bottom: 3.81vW
        padding-top: 5vW
        @include respond-to(xs)
          opacity: 1
        >*
          padding-right: 3.81vW
        .title
          display: block
          @include respond-to(xs)
            display: none
    .gallery-desktop
      .captions
        position: absolute
        bottom: 0
        width: 78.79vW
        color: #FFF
        padding-left: 3.81vW
        background: linear-gradient(rgba(255,255,255,0), rgba(0,0,0,0.75))
        h1
          letter-spacing: $kerningTight
    .half-screen
      width: 100%
      height: 76.5vH
      @include respond-to(xs)
        padding-bottom: 58%
        height: 0
      .vv-image
        width: 100%
        height: 76.5vH
        @include respond-to(xs)
          padding-bottom: 58%
          height: 0
    .gallery-desktop
      width: 92.3vW
      margin: auto
      .swiper-slide
        display: flex
        justify-content: center
      .vv-visual
        width: 82.6vW
        height: 76.5vH
      .vv-image
        width: 100%
        height: 76.5vH
        background-repeat: no-repeat
        background-size: cover
      .swiper-button-prev
        background-image: url('/static/icons/left_arrow.svg')
      .swiper-button-next
        background-image: url('/static/icons/right_arrow.svg')
      @include respond-to(xs)
        display: none
    .gallery-mobile
      display: none
      @include respond-to(xs)
        display: block
        .screen
          margin-bottom: 2rem
      .vv-visual
        width: 100%
        height: 0
        padding-bottom: 58%
      .vv-image
        width: 100%
        height: 0
        padding-bottom: 58%
</style>



// WEBPACK FOOTER //
// Exhibitions.vue?0dc6d4af